import { AxiosError } from 'axios';
import instance from '../config/axios';
import { UserInfoResponse } from '../interface/interface';

export const manageNotification = async (
  accessToken: string,
  data: { isNotificationEnabled: boolean; email: string },
): Promise<number> => {
  try {
    const response = await instance({
      url: '/api/v1/user/notification/manage',
      method: 'PUT',
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};

export const getUserInfo = async (
  accessToken: string,
): Promise<UserInfoResponse | number> => {
  try {
    const response = await instance({
      method: 'GET',
      url: '/api/v1/user',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};
